import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalSearch.GlobalSearchFirstRunState'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "Search across all your Procurify's modules",
  },
  content: {
    id: `${scope}.content`,
    defaultMessage:
      'Find orders, bills, payments, and vendors in one place. Type a name, a number, or ask a question like "pending orders from Amazon."',
  },
})
